var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"home-section mb-2"},[_c('div',{staticClass:"container"},[[_c(_vm.attributes.theme,{key:_vm.attributes.theme,tag:"component",attrs:{"topNews":_vm.topNews,"cat1Posts":_vm.cat1Posts,"cat1name":_vm.cat1name}})]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }